import styles from '@ui/components/Video/Video.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import React, { useRef, useState, useEffect } from 'react';
import { Button } from '@ariakit/react';
import PropTypes from 'prop-types';

const Video = ({
  poster = null,
  video = null,
  track = null,
  autoPlay = false,
  loop = true,
  muted = true,
  controls = false,
  className = null,
  preload = 'none',
  title = null,
  style,
}) => {
  const videoParentRef = useRef(null);
  const [videoState, setVideoState] = useState(null);
  const handlePlayClick = () => {
    if (!videoParentRef.current) {
      return;
    }

    const player = videoParentRef.current;
    player.play();
  };

  useEffect(() => {
    if (!videoParentRef.current) {
      return;
    }

    // obtain reference to the video element
    const player = videoParentRef.current;

    player.classList.add(className);
    player.controls = controls;
    player.playsinline = true;
    player.autoplay = autoPlay;
    player.loop = loop;

    if (muted) {
      player.muted = muted;
      player.setAttribute('muted', ''); // leave no stones unturned :)
    }

    if (preload) {
      player.setAttribute('preload', preload);
    }

    if (poster) {
      player.poster = poster;
    }

    if (title) {
      player.setAttribute('title', title);
    }

    setTimeout(() => {
      player.addEventListener(
        'play',
        () => {
          setVideoState('play');
        },
        false,
      );

      if (autoPlay) {
        player.play();
      }
    }, 0);
  }, []);

  if (!video) {
    return null;
  }

  return (
    <div className={styles.container}>
      {!autoPlay && videoState !== 'play' && (
        <Button
          aria-label="Video abspielen"
          className={styles.overlay}
          onClick={handlePlayClick}
          render={
            <div>
              <FontAwesomeProIcon
                className={styles.actionIcon}
                icon="play-circle"
                role="presentation"
              />
            </div>
          }
        />
      )}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        className={styles.video}
        height={video.height}
        playsInline
        ref={videoParentRef}
        style={style}
        width={video.width}
      >
        <source src={video.src} type="video/mp4" />
        {track && (
          <track kind="subtitles" label="Deutsch" src={track} srcLang="de" />
        )}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

Video.propTypes = {
  autoPlay: PropTypes.bool,
  className: PropTypes.string,
  controls: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  poster: PropTypes.string,
  preload: PropTypes.oneOf(['auto', 'metadata', 'none']),
  /* eslint-disable-next-line react/forbid-prop-types */
  style: PropTypes.object,
  title: PropTypes.string,
  track: PropTypes.string,
  video: PropTypes.shape({
    height: PropTypes.number,
    src: PropTypes.string,
    width: PropTypes.number,
  }),
};

export default Video;
